var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme, { mediaQueries, theme } from 'Theme';
import { Scroll } from 'elements';
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hide: _this.props.hide
        };
        _this.handleClose = function (event) {
            // Si se hace clic directamente en el overlay (fuera del contenido del modal), cerramos el modal
            if (event.target === event.currentTarget && _this.props.closeOutside) {
                if (_this.props.onClose) {
                    return _this.props.onClose();
                }
                else {
                    return _this.setState({ hide: true });
                }
            }
        };
        return _this;
    }
    Modal.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevState.hide !== this.props.hide) {
            this.setState({ hide: !prevState.hide });
        }
    };
    Modal.prototype.render = function () {
        var _a = this.props, title = _a.title, children = _a.children, hide = _a.hide, onClose = _a.onClose, buttonClose = _a.buttonClose, props = __rest(_a, ["title", "children", "hide", "onClose", "buttonClose"]);
        if (this.state.hide)
            return null;
        return (React.createElement(Wrapper, null,
            React.createElement(Backdrop, { onClick: this.handleClose },
                React.createElement(Content, __assign({}, props),
                    (title || (typeof buttonClose === 'function')) && React.createElement(Title, null,
                        buttonClose && buttonClose(),
                        title),
                    React.createElement(Scroll, null, children)))));
    };
    return Modal;
}(Component));
// @ts-ignore
Modal.propTypes = {
    title: PropTypes.string,
    buttonClose: PropTypes.func,
};
export default Modal;
var Wrapper = cxs('div')({
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10
});
var Backdrop = cxs('div')({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: Theme.color.backdrop,
    zIndex: 'inherit'
});
var Title = cxs('div')({
    minHeight: theme.size.bar,
    position: 'relative',
    fontSize: Theme.fontSize.big,
    textAlign: 'center',
    padding: Theme.size.space[1],
    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline)
});
var Content = cxs('div')((_a = {
        position: 'relative',
        margin: 'auto',
        transform: 'translateY(-50%)',
        top: '50%',
        maxWidth: '90%',
        maxHeight: '80%',
        backgroundColor: Theme.color.background,
        zIndex: 'inherit'
    },
    _a[mediaQueries.desktop] = {
        maxWidth: '600px'
    },
    _a));



//////////////////
// WEBPACK FOOTER
// ./src/components/Modal.tsx
// module id = 459
// module chunks = 0